const ITEMS = [
  "Patios & Pavers",
  "Masonry",
  "Retaining Walls",
  "Drainage",
  "Landscape Design",
  "Lawn & Maintenance",
  "Outdoor Kitchens",
  "Pool Landscaping",
  "Irrigation",
];

function Row({ hidden }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap px-7 text-[13px] font-medium uppercase tracking-[0.16em] text-dim">
            {item}
          </span>
          <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-accent/70" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      className="overflow-hidden border-y border-line py-4"
      role="presentation"
      data-testid="services-marquee"
    >
      <div className="marquee-track flex w-max">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
